import { useState } from "react";
import { Colors } from "../style/theme";

const ReadMore = ({ children, length = 15 }) => {
  const [expanded, setExpanded] = useState(false);
  const text = typeof children === "string" ? children : "";

  if (text.length <= length) return <span>{text}</span>;

  return (
    <span>
      {expanded ? text : text.slice(0, length)}
      <span onClick={() => setExpanded(!expanded)} style={{ color: Colors.primary, cursor: "pointer" }}>
        {expanded ? " ...less" : " ...more"}
      </span>
    </span>
  );
};

export default ReadMore;
